export const FIELD_ERROR_MESSAGES = {
  default: 'field_error_default',
  required: 'field_error_required',
  invalidAutocomplete: 'field_error_autocomplete',
  invalidValue: 'filter_invalid_selection',
  password: 'field_error_password',
  fullName: 'field_error_fullname'
};
